<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <p>
    {{ content }}
    <a [href]="fileUrl" (click)="trackEvent(downloadEventName)" target="_blank">
      Click here.
    </a>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger text-white" ngbAutofocus (click)="activeModal.dismiss()">
    Close
  </button>
  <a [href]="fileUrl" (click)="trackEvent(downloadEventName)" target="_blank" class="btn btn-success text-white">
    View/Download
  </a>
</div>
